import {
  keepPreviousData,
  queryOptions,
  useQuery,
} from '@tanstack/react-query';

import { baseAPI } from '~shared/api/base-api';
import { KEYS } from '~shared/api/query-keys';

export interface GetEventCalendarParams {
  startDate?: string;
  endDate?: string;
}

export interface EventCalendarResponse {
  data: Array<{
    title: string;
    start: string;
    end: string;
    resourceId: string; // Changed to string
    color: string;
    days: Array<string>; // Added days array
  }>;
  total: number;
  page: number;
  lastPage: number;
}

export const getEventCalendarAPI = async (params: GetEventCalendarParams) => {
  const response = await baseAPI.get<EventCalendarResponse>(
    `/events/calendar/all`,
    {
      params,
    },
  );
  return response.data;
};

export const getEventCalendarQueryOptions = (params: GetEventCalendarParams) =>
  queryOptions({
    queryKey: [KEYS.EVENTS, params],
    queryFn: () => getEventCalendarAPI(params),
    placeholderData: keepPreviousData,
    staleTime: 1000 * 60 * 5,
  });

export const useGetEventCalendar = (params: GetEventCalendarParams) => {
  return useQuery(getEventCalendarQueryOptions(params));
};
